/**
 * 商品詳細ページ管理
 */
class ProductController{
    constructor(){
    }
    /**
     * 初期化
     */
    init(){
        this.elements = {
            selectors : {
                optionSelectAll            : '[name="option"]',
                quantitySelectAll          : '[name="quantity"]',
                propertiesAll              : '[name^="properties"]',
                validateTriggerAll         : '[data-validate-target]'
            }
        };
        this.initDataElements();
        this.initEvents();
        this.initDescription();
    }
    /* 指定要素の指定イベント強制発火 */
    triggerEvent(element, event){
        if (document.createEvent) {
            const evt = document.createEvent("HTMLEvents");
            evt.initEvent(event, true, true );
            return element.dispatchEvent(evt);
        } else {// IE
            const evt = document.createEventObject();
            return element.fireEvent("on"+event, evt)
        }
    }
    /* optionsからバリエーションID取得 */
    getVariantIdByOptions(options){
        const variant = window.product.variants.find((variant,index)=>{
            return variant.options === options;
        });
        return variant ? variant.id : 0;
    }
    /* data-variant属性を持つ要素にhideクラス付与 */
    hideByDataVariant(){
        const elms = document.querySelectorAll('[data-variant]');
        elms.forEach((elm,index)=>{
            elm.classList.add('hide');
        });
    }
    /* data-variant=variantIdの要素からhideクラス削除 */
    showByDataVariant(variantId){
        const elms = document.querySelectorAll('[data-variant="'+variantId+'"]');
        elms.forEach((elm,index)=>{
            elm.classList.remove('hide');
        });
    }
    /* this.elements初期化 */
    initDataElements(){
        let key;
        for(key in this.elements.selectors){
            if(this.elements.selectors[key]) {
                if (/^.+All$/.test(key)) {
                    this.elements[key] = document.querySelectorAll(this.elements.selectors[key]);
                }else {
                    this.elements[key] = document.querySelector(this.elements.selectors[key]);
                }
                if (/^.+Clone$/.test(key)) {
                    this.elements[key] = this.elements[key].cloneNode(true);
                }
            }
        }
    }
    /* イベント初期化 */
    initEvents(){
        /* オプション */
        this.elements.optionSelectAll.forEach((elm,index)=>{
            elm.addEventListener('change',(e)=>{
                this.onChange(e);
            });
        });
        /* 数量 */
        this.elements.quantitySelectAll.forEach((elm,index)=>{
            elm.addEventListener('change',(e)=>{
                this.onChangeQuantity(e);
            });
            this.triggerEvent(elm,'change');
        });
        /* 名入れ */
        this.elements.propertiesAll.forEach((elm,index)=>{
            elm.addEventListener('blur',(e)=>{
                this.onBlur(e);
            });
        });
        /* オプション未選択エラー表示 */
        this.elements.validateTriggerAll.forEach((elm,index)=>{
            elm.addEventListener('click',(e)=>{
                this.onClickValidate(e);
            });
        });
    }
    /* オプション変更時 */
    onChange(e){
        this.updateOptions(e.target.dataset.optionIndex);
        const variantId = this.getVariantIdByOptions(this.getOptionValues(','));
        this.hideByDataVariant();
        this.showByDataVariant(variantId);
    }
    /* 選択軸が2つ以上時選択出来るオプションを更新する */
    updateOptions(optionIndex){
        let optionElms,optionValues,isExists;
        this.elements.optionSelectAll.forEach((elm,index)=>{
            if(elm.dataset.optionIndex != optionIndex){
                optionValues = this.getOptionValues();
                optionElms = elm.querySelectorAll('option');
                optionElms.forEach((optionElm,i)=>{
                    if(optionElm.value){
                        optionValues[index] = optionElm.value;
                        isExists = this.isExistsByOptionValues(optionValues);
                        optionElm.disabled = !isExists;
                    }
                });
            }
        });
    }
    /* 現在選択中のオプションの値を取得 */
    getOptionValues(glue){
        let options = [];
        this.elements.optionSelectAll.forEach((elm,index)=>{
            options[elm.dataset.optionIndex] = elm.value;
        });
        return glue ? options.join(glue) : options;
    }
    /* 指定したオプションのバリエーションの存在判定 */
    isExistsByOptionValues(options){
        let regs = [];
        options.forEach((optionValue,i)=>{
            if(optionValue === ''){
                regs.push('[^,]+');
            }else{
                regs.push(optionValue);
            }
        });
        const pattern = new RegExp('^'+regs.join(',')+'$');
        const variant = window.product.variants.find((variant,index)=>{
            return pattern.test(variant.options);
        });
        return variant ? true : false;
    }
    /* 数量変更時 */
    onChangeQuantity(e){
        const quantity = e.target.value * 1;
        let i,elms,input;
        elms = document.querySelectorAll('[data-quantity-index]');
        elms.forEach((elm,index)=>{
            i = elm.dataset['quantityIndex'];
            if(i < quantity){
                elm.classList.remove('hide');
            }else{
                elm.classList.add('hide');
                input = elm.querySelector('input');
                if(input) {
                    input.value = '';
                }
            }
        });
    }
    /* 名入れblur時 */
    onBlur(e){
        if (!/^([0-9a-z\s -/:-@[-~]{0,20})$/.test(e.target.value)) {
            alert("半角英数字20文字以内・小文字で入力してください");
            e.target.value = '';
            e.preventDefault();
        }
    }
    /* オプション未選択エラー表示 */
    onClickValidate(e){
        const targets = document.querySelectorAll(e.target.dataset['validateTarget']);
        let i,elm,hasError = false;
        for(i=0;i<targets.length;i++){
            elm = targets[i];
            hasError = false;
            if(elm.dataset['title']){
                if (elm.validity.valueMissing) {
                    elm.setCustomValidity(elm.dataset['title']);
                    hasError = true;
                } else if (elm.validity.rangeUnderflow) {
                    elm.setCustomValidity(elm.dataset['title']);
                    hasError = true;
                } else if (elm.validity.rangeOverflow) {
                    elm.setCustomValidity(elm.dataset['title']);
                    hasError = true;
                } else {
                    elm.setCustomValidity('');
                }
                elm.reportValidity();
                if(hasError){
                    break;
                }
            }
        }
    }
    /* wysiwyg不具合対策 */
    initDescription(){
        const elm = document.getElementById('mouseposition-extension-element-full-container');
        if(elm){
            elm.removeAttribute('style');
        }
    }
}
window.addEventListener('DOMContentLoaded',(e) => {
    const pc = new ProductController();
    pc.init();
});